import { useOutletContext } from "react-router-dom";

import { type SessionRecord } from "@/shared/domain/sessions";

export interface SessionOutletContext {
  session: SessionRecord;
}

/**
 * Typed accessor for the outlet context the `SessionLayout` publishes
 * to its child tab routes. Keeps the `<SessionRecord>` shape in one
 * place so per-tab consumers don't repeat the cast.
 *
 * Throws if called outside a `<SessionLayout />` outlet — react-router's
 * `useOutletContext` returns `null` in that case, which the hook surfaces
 * as a named error so the misuse points at this hook rather than at a
 * downstream destructure.
 */
export function useSessionOutletContext(): SessionOutletContext {
  const context = useOutletContext<SessionOutletContext | null>();
  if (context === null) {
    throw new Error(
      "useSessionOutletContext must be called inside a <SessionLayout /> outlet",
    );
  }
  return context;
}
